import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_footprint_generic_json_inventory_export_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { project_lookup_code?: string, material_lookup_code?: string, warehouse_name?: string, render_lots?: boolean, render_license_plates?: boolean, render_serial_numbers?: boolean, integration_name?: string, transaction_id?: string }): Promise<{ messages?: string[], DatexInventoryInfo?: $frontendTypes.FootprintApiManager.DatexInventoryInfo }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

